module.exports = __webpack_public_path__ + "img/newtwitter.aa928ce0.svg";